import * as React from "react";
import { useAppSelector } from "../../../store/hooks";
import { selectDarkLogoUrl, selectLightLogoUrl } from "../../../store/restSlice";

export const Logo: React.FC = () => {
  const theme = useAppSelector((state) => state.theme.theme);
  const lightLogoUrl = useAppSelector(selectLightLogoUrl);
  const darkLogoUrl = useAppSelector(selectDarkLogoUrl);

  // Use default logos unless custom logo URL is actually loaded
  let src =
    theme === "dark" ? `/resources/logos/controlPlaneLogoWhite.svg` : `/resources/logos/controlPlaneLogo.svg`;

  const customUrl = theme === "dark" ? darkLogoUrl : lightLogoUrl;
  if (customUrl) {
    src = customUrl;
  }

  return (
    <div className="ngheader-logo-container">
      <img
        className="object-contain cursor-pointer relative"
        src={src}
        style={{ maxWidth: 95, height: 56 }}
        alt="Control Plane Logo"
      />
    </div>
  );
};
